import { render, staticRenderFns } from "./ebudgets-04-product.vue?vue&type=template&id=108c0412"
import script from "./ebudgets-04-product.vue?vue&type=script&lang=js"
export * from "./ebudgets-04-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports